document.addEventListener('DOMContentLoaded', function () {
  const headings = document.querySelectorAll('.footer__section-head h5');
  headings.forEach(function (heading) {
    if (heading.textContent.trim() === 'ご利用ガイド') {
      const link = document.createElement('a');
      link.href = '/pages/use-guide'; // ←リンク先は必要に応じて変更
      link.textContent = heading.textContent.trim();
      link.style.color = 'inherit';
      link.style.textDecoration = 'none';
      heading.textContent = '';
      heading.appendChild(link);
    }
  });
});
